import { Component, OnInit } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
  selector: 'app-go-to-groups-dialog',
  templateUrl: './go-to-groups-dialog.component.html',
  styleUrls: ['./go-to-groups-dialog.component.scss']
})
export class GoToGroupsDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GoToGroupsDialogComponent>,
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

  goToGroups() {
    window.location.href = environment.groupsUrl;
  }

}
